<mat-checkbox [checked]="this.value" (click)="next()" [disabled]="disabled" [indeterminate]="value === false">
  <ng-content></ng-content>
</mat-checkbox>
